import React, { useEffect } from "react"
import { Box, Text, Alert, Loader, Flex } from "@singita/components"
import { motion, AnimatePresence } from "framer-motion"

/**
 * RecaptchaV2 Component
 * Renders the visible reCAPTCHA v2 checkbox widget with animations and feedback
 */
const RecaptchaV2 = ({
  containerRef,
  isVisible,
  isLoading,
  error,
  hasToken,
  onInit,
}) => {
  useEffect(() => {
    if (isVisible && onInit) {
      onInit()
    }
  }, [isVisible, onInit])

  if (!isVisible) {
    return null
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{ width: "100%" }}
      >
        <Box mb={2}>
          {/* Loading state */}
          {isLoading && (
            <Flex justifyContent="flex-start" alignItems="center" py={3}>
              <Loader isActive={true} size={40} />
            </Flex>
          )}
          {/* reCAPTCHA v2 container - simplified styling */}
          {!isLoading && (
            <div
              style={{
                display: "inline-block",
                background: "rgba(248, 250, 252, 0.5)",
                borderRadius: "8px",
                padding: "16px",
                border: "1px solid rgba(226, 232, 240, 0.8)",
                minHeight: "110px",
              }}
            >
              <div
                ref={containerRef}
                style={{
                  minHeight: "78px",
                }}
              />
            </div>
          )}
          {/* Error message */}
          {error && (
            <Alert variant="standard" mt={2}>
              <Text size="small" color="statusError">
                {error}
              </Text>
            </Alert>
          )}
        </Box>
      </motion.div>
    </AnimatePresence>
  )
}

export default RecaptchaV2
